var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"team-code",attrs:{"title":_vm.t('codeHelp')}},[_c('code',[_vm._v(_vm._s(_vm.value || '—'))]),(_vm.value)?_c('a-button',{attrs:{"type":"link","size":"small"},on:{"click":_vm.copy}},[_vm._v(_vm._s(_vm.t('copy')))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }